import { render, staticRenderFns } from "./ModalPromoApp.vue?vue&type=template&id=86d13ff2&scoped=true&"
import script from "./ModalPromoApp.vue?vue&type=script&lang=js&"
export * from "./ModalPromoApp.vue?vue&type=script&lang=js&"
import style0 from "./ModalPromoApp.vue?vue&type=style&index=0&id=86d13ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d13ff2",
  null
  
)

export default component.exports